export interface AuthSession {
  accessToken: string
  refreshToken: string
  tenantId: string
  userId: string
  expiresTime?: string
  recoveryMode?: boolean
  passwordChangeRequired?: boolean
}

const SESSION_KEY = 'leshe-admin-auth'

export function readSession(): AuthSession | null {
  const value = sessionStorage.getItem(SESSION_KEY)
  if (!value) return null
  try {
    const parsed = JSON.parse(value) as AuthSession
    return parsed.accessToken && parsed.tenantId ? parsed : null
  } catch {
    return null
  }
}

export function writeSession(value: AuthSession | null) {
  if (value) sessionStorage.setItem(SESSION_KEY, JSON.stringify(value))
  else sessionStorage.removeItem(SESSION_KEY)
}

export function getOrCreateDeviceId() {
  const key = 'leshe-admin-device-id'
  const existing = localStorage.getItem(key)
  if (existing) return existing
  const value = crypto.randomUUID()
  localStorage.setItem(key, value)
  return value
}
